<template>
	<BasicLayout>
		<el-row>
			<el-col :xs="{span: 18, offset: 3}" :sm="{span: 16, offset: 4}" :md="{span: 12, offset: 6}" :lg="{span: 8, offset: 8}">
				<el-card>
					<div class="details">Aïe ! Une erreur est survenue.</div>
					<div class="code red-color">{{ errorCode }}</div>
					<div class="details bold">{{ errorTitle }}</div>
					<div class="details message" v-if="errorMessage">{{ errorMessage }}</div>
					<div class="button-container"><el-button type="danger" plain @click="$router.push('/')">Retour</el-button></div>
				</el-card>
			</el-col>
		</el-row>
	</BasicLayout>
</template>

<script>
import BasicLayout from '@/layouts/basic.layout.vue'
import store from '@/store'

export default {
	name: 'error',
	components: {
		BasicLayout
	},
	computed: {
		errorCode: function() {
			let errorCode = store.state.error.errorCode

			if (errorCode < 400 || errorCode > 599) {
				errorCode = 418
			}

			return errorCode
		},
		errorTitle: function() {
			let title
			switch (store.state.error.errorCode) {
				case 400:
					title = 'Requête erronée.'
					break
				case 403:
					title = 'Accès refusé.'
					break
				case 404:
					title = 'Elément non trouvé.'
					break
				case 500:
					title = 'Erreur serveur.'
					break
				default:
					title = 'Erreur inconnue.'
			}
			return title
		},
		errorMessage: function() {
			return store.state.error.errorMessage
		}
	}
}
</script>

<style scoped>

.code {
	font-size: 96px;
	text-align: center;
}

.details {
	text-align: center;
	font-size: 14px;
}

.bold {
	font-weight: bold;
}

.message {
	margin-top: 15px;
	font-size: 12px;
}

.button-container {
	margin-top: 25px;
	text-align: center;
}

</style>
